<template>
  <div class="lawyerDetail" v-wechat-title="$route.meta.title">
    <Header :class="{print_statue: printStatue}"/>
    <BannerBg :class="{print_statue: printStatue}"/>
        <div class="ewm_box qrcode_share_box wow BounceIn animated">
            <div class="close_ewm_box" @click="qrcodeLawyerHide" >×</div>
            <div id="qrcodelawyer"></div>
            <p>
                打开微信，扫一扫二维码,<br>
                打开页面后，点击右上角的三点,<br>
                即可分享给朋友或分享到朋友圈。
            </p>
        </div>
        <div class="lawyer_content">
            <div class="site_width">
                <div class="width4">
                    <div class="padding15 padding_right40" style="line-height: 1;">
                        <div class="lawyer_left">
                            <img :src=tableData.pic>
                            <div class="lawyer_doc pc_only_i">
                              <div style="text-align: center;" v-if="printStatue">
                                <p>{{ tableData.email }}</p>
                                <p>{{ tableData.mobile }}</p>
                              </div>
                              <ul v-else>
                                <li>
                                  <a :href="'mailto:' + tableData.email">邮箱：{{ tableData.email }}</a>
                                </li>
                                <li>电话：+86-{{ tableData.mobile }}
                                </li>
                              </ul>
                            </div>
                            <!-- <div class="lawyer_btn phone_only_i" :class="{print_statue: printStatue}">
                                <span class="dr"><a target="_blank"><em>下载简历</em></a></span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="width4 phone_only_i">
                    <div class="padding15">
                        <div class="lawyer_title">
                            <h1>
                                {{ tableData.userName }}
                            <!-- </h1><font>{{ changeQcValue(tableData.qualification) }}</font> -->
                            </h1><font>{{ tableData.qualification }}</font>
                        </div>
                    </div>
                </div>
                <div class="width8">
                    <div class="padding15">
                        <div class="lawyer_title pc_only_i">
                            <h1>
                                {{ tableData.userName }}
                            </h1><font>{{ tableData.qualification }}</font>
                            <div class="lawyer_btn" :class="{print_statue: printStatue}">
                                <span class="dr">
                                    <a @click="htmlCanvasLawyer" target="_blank">
                                        <i class="fa fa-download"></i>
                                        <em>下载简历</em>
                                    </a>
                                </span> 
                                <span class="dc">
                                    <a @click="qrcodeLawyerShow">
                                        <i class="fa fa-share-square-o"></i>
                                        <em>分享简历</em>
                                    </a>
                                </span>
                            </div>
                        </div>
                        <div class="lawyer_detail phone_only_i">
                            <h2>
                                联系方式
                            </h2>
                            <div class="detail_line"></div>
                        </div>
                        <div class="lawyer_detail_list phone_only_i">
                            <ul class="yewu_list">
                                <li>邮箱：{{ tableData.email }}
                                </li>
                                <li>电话：+86-{{ tableData.mobile }}
                                </li>
                            </ul>
                        </div><!--工作领域-->
                        <div class="lawyer_detail">
                            <h2>
                                工作领域
                            </h2>
                            <div class="detail_line"></div>
                        </div>
                        <div class="lawyer_detail_list">
                            <ul class="yewu_list">
                                <li v-for="item in tableData.field" :key="item.key" >
                                    {{ item.value }}
                                </li>
                            </ul>
                        </div><!--工作简历-->
                        <div class="lawyer_detail">
                            <h2>
                                工作简历
                            </h2>
                            <div class="detail_line"></div>
                        </div>
                        <div class="lawyer_detail_list">
                            <ul class="yewu_list">
                                <li v-for="item in tableData.achievement" :key="item.key" >
                                    {{ item.value }}
                                </li>
                            </ul>
                        </div><!--教育背景-->
                        <!-- <div class="lawyer_detail">
                            <h2>
                                教育背景
                            </h2>
                            <div class="detail_line"></div>
                        </div>
                        <div class="lawyer_detail_list">
                            <ul class="yewu_list">
                                <li>上海交通大学涉外经济法专业法学学士
                                </li>
                                <li>华东政法大学经济法专业法律硕士
                                </li>
                            </ul>
                        </div> -->
                        <!--执业荣誉-->
                        <!-- <div class="lawyer_detail">
                            <h2>
                                执业荣誉
                            </h2>
                            <div class="detail_line"></div>
                        </div>
                        <div class="lawyer_detail_list">
                            <ul class="yewu_list">
                                <li>1999年度浦东新区司法行政系统先进个人
                                </li>
                                <li>2000-2001年度浦东新区司法行政系统优秀共产党员
                                </li>
                                <li>2007-2008年度静安区优秀专业律师
                                </li>
                            </ul>
                        </div> -->
                        <!--社会职务-->
                        <!-- <div class="lawyer_detail">
                            <h2>
                                社会职务
                            </h2>
                            <div class="detail_line"></div>
                        </div>
                        <div class="lawyer_detail_list">
                            <ul class="yewu_list">
                                <li>中华律师协会会员
                                </li>
                                <li>上海律师协会会员
                                </li>
                                <li>上海市律师协会文化传媒业务研究委员会委员
                                </li>
                            </ul>
                        </div> -->
                        <!--著作论文-->
                        <!--工作语言-->
                        <div class="lawyer_detail">
                            <h2>
                                工作语言
                            </h2>
                            <div class="detail_line"></div>
                        </div>
                        <div class="lawyer_detail_list">
                            <ul class="yewu_list">
                                <li>{{ tableData.language }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>   
    <Footer :class="{print_statue: printStatue}"/>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    name: "lawyerDetail",
    data() {
      return {
        tableData: {},
        params: {
          id: 0
        },
        printStatue: false,
        htmlUpload:'',
        qcOptions: [
          {id: 0, label: '高级合伙人'},
          {id: 1, label: '合伙人'},
          {id: 2, label: '顾问'},
          {id: 3, label: '资深律师'},
          {id: 4, label: '律师'},
          {id: 5, label: '律师助理'}
        ]
      }
    },
    mounted() {
      this.params.id = this.$route.params.id
      this.htmlUpload = this.$apiUrl.LAWYER_GET_API_URL + this.params.id
      this.qrcodeLawyer()
      // 第一次初始化组件时，要调用函数进行获取id并查找数据
      this.getLawyerById ()
    },
    methods: {
      getLawyerById () {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.LAWYER_GET_API_URL, 'Json', this.params)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.tableData = res.data.data
            this.tableData.achievement = JSON.parse(this.tableData.achievement)
            this.tableData.field = JSON.parse(this.tableData.field)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          this.isLoading = false
          this.$message.error("服务器出现差错")
        })
      },
      htmlCanvasLawyer() {
        document.getElementsByTagName('body')[0].style.height = '0px';
        document.getElementsByTagName('html')[0].style.height = '0px';
        window.scrollTo(0,0);
        this.printStatue = true;
        setTimeout(() => {
          window.print(); //  调用打印功能
          this.printStatue = false;
          document.getElementsByTagName('body')[0].style.height = '100%';
          document.getElementsByTagName('html')[0].style.height = '100%';
        }, 1000);
      },
      // 律师二维码
      qrcodeLawyer () {
        setTimeout(() => {
          var qrcodecontext = document.location.href;
          qrcodecontext = qrcodecontext.substring(0, 4).toLowerCase() == "http" ? qrcodecontext : "http://" + qrcodecontext;
          var qrnode = new QRCode('qrcodelawyer', { correctLevel: 0, text: qrcodecontext, width: 140, height: 140, background: "#fff", foreground: "#000" });
        }, 1000);
      },
      changeQcValue(val) {
        if (val == undefined) {
            return ''
        }
        let obj = {}
        obj = this.qcOptions.find((item)=>{
          return item.id == val
        })
        return obj.label
      },
      qrcodeLawyerShow() {
        $(".lawyer_btn .dc").click(function(){
          $(".black_bg").show()
          $(".qrcode_share_box").show()
        })
      },
      qrcodeLawyerHide() {
        $(".black_bg").hide()
        $(".qrcode_share_box").hide()
      }
    },
    watch: { // watch 是对象，用于监听属性使用
      '$route': function () {
        this.getLawyerById()
      }
    }
  }
</script>
<style scoped>
  .print_statue {
    display: none;
  }
</style>